import request from "@/lib/api/handler";
import HttpError from "@/lib/api/httpError";

import { useAuth0 } from "@auth0/auth0-react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

export const useMakeMilestonePayment = () => {
  const { getAccessTokenSilently } = useAuth0();

  const { mutate, isPending, error } = useMutation({
    mutationFn: async (data: { billingTermId: string }) => {
      const token = await getAccessTokenSilently();

      return request<{ checkoutUrl: string }>({
        method: "POST",
        path: `/api/payment/milestone/billingTerm/${data.billingTermId}/checkout`,
        token,
      });
    },
    onSuccess(data) {
      window.location.assign(data.checkoutUrl);
    },
    onError(error) {
      if (error instanceof HttpError) {
        toast.error(error.message);
      }
    },
  });

  return {
    makeMilestonePayment: mutate,
    isMakingMilestonePayment: isPending,
    makeMilestonePaymentError: error,
  };
};
